export default __webpack_public_path__ + "static/media/recording-paused-icon.8ce2e68d.svg";